/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/thumbs_up'
export default icon
